import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'

var pedidoMinimo,pedidos,produtos,qtdTotalItens;

function validatePedidoMinimo(regrasPedidoMinimo,listaPedidos,listaProdutos,totalItens){

pedidoMinimo = regrasPedidoMinimo;
pedidos = listaPedidos;
produtos = listaProdutos;
qtdTotalItens = totalItens;


	switch(pedidoMinimo.restricao){
		case 'ITEM':

		return validateMinimoItens()
		break;

		case 'PRODUTO':
		return validateMinimoProduto();
		break ;

		case 'VALOR':
		return validateMinimoValor();
		break;

		default:
		//alert("Falha nas configurações de Pedido Mínimo");
		Swal.fire('Ops','Falha nas configurações do pedido mínimo','error');
	}
	return false;
}


function validateMinimoProduto(){

	var totalProdutos = 0;
	
	Object.keys(pedidos).forEach(function(item){

		let quantidade = pedidos[item].quantidade;
		let aproveitadoEstoque = pedidos[item].aproveitadoEstoque;
		if(quantidade > aproveitadoEstoque){
			totalProdutos++;
		}
	});

	if(totalProdutos < pedidoMinimo.valor){
		Swal.fire("Ops","A quantidade mínima de Produtos excluindo o estoque deve ser " + pedidoMinimo.valor + "\n Valor Atual: "+ totalProdutos,"error");
		return false;
	}

	return true;
}

function validateMinimoItens(){
	if(qtdTotalItens < pedidoMinimo.valor){
		Swal.fire("ops","A quantidade mínima de Ítens excluindo o estoque deve ser " + pedidoMinimo.valor + "\n Valor Atual: "+ qtdTotalItens,'error');
		return false;
	}
	return true;
}

function validateMinimoValor(){

	var total = 0;


	Object.keys(pedidos).forEach(function(item){

		let itens = parseInt(pedidos[item].quantidade) - parseInt(pedidos[item].aproveitadoEstoque);

		total+= itens * parseFloat(produtos[item].preco);
	});

	if(total < pedidoMinimo.valor){
		Swal.fire("Ops",`O Valor mínimo excluindo o estoque deve ser R$ ${parseFloat(pedidoMinimo.valor).toFixed(2).replace('.',',')} \n Valor Atual: R$ ${parseFloat(total).toFixed(2).replace('.',',')}`,'error');
		return false;
	}
	return true;
}

export default validatePedidoMinimo;


// WEBPACK FOOTER //
// ./resources/assets/js/components/pedidos/create/modules/validate_pedido_minimo.js